import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BatteryWarning, Brain, Activity } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-24 bg-[#275a3a] relative border-y border-white/8 overflow-hidden" data-id="element-120">
      {/* Decorative Elements */}
      <span className="absolute top-8 right-12 text-4xl opacity-[0.06] pointer-events-none select-none" data-id="element-121">
        😴
      </span>
      <span className="absolute bottom-12 left-8 text-4xl opacity-[0.06] pointer-events-none select-none" data-id="element-122">
        🍩
      </span>
      <span className="absolute top-1/2 right-4 text-3xl opacity-[0.05] pointer-events-none select-none" data-id="element-123">
        ⚡
      </span>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-125">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-126">
            Después de los 40, las reglas del juego{' '}
            <span className="text-emerald-400" data-id="element-127">cambian radicalmente.</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto" data-id="element-128">
            El metabolismo que te permitía dormir poco y comer cualquier cosa a
            los 25 ha sido reemplazado por un sistema hipersensible al estrés.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-129">
          <motion.div variants={itemVariants} className="bg-[#2f5c3d] p-8 rounded-2xl border border-white/8 hover:border-emerald-500/30 transition-colors" data-id="element-130">
            <BatteryWarning className="w-10 h-10 text-emerald-400 mb-6" data-id="element-131" />
            <p className="text-gray-300 leading-relaxed" data-id="element-132">
              Si te despiertas sintiéndote "borracho" de cansancio aunque hayas
              dormido 8 horas
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-[#2f5c3d] p-8 rounded-2xl border border-white/8 hover:border-emerald-500/30 transition-colors" data-id="element-133">
            <Brain className="w-10 h-10 text-emerald-400 mb-6" data-id="element-134" />
            <p className="text-gray-300 leading-relaxed" data-id="element-135">
              Si experimentas una neblina mental que te impide enfocarte después
              del almuerzo
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-[#2f5c3d] p-8 rounded-2xl border border-white/8 hover:border-emerald-500/30 transition-colors" data-id="element-136">
            <Activity className="w-10 h-10 text-emerald-400 mb-6" data-id="element-137" />
            <p className="text-gray-300 leading-relaxed" data-id="element-138">
              Si sientes que tu cuerpo ahorra energía agresivamente en forma de
              grasa abdominal
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="text-center max-w-3xl mx-auto" data-id="element-139">
          <p className="text-xl text-gray-300 italic" data-id="element-140">
            ...tus mitocondrias están asustadas. Están priorizando la
            supervivencia sobre tu rendimiento, apagando tus interruptores de
            energía uno a uno.
          </p>
        </motion.div>
      </div>
    </section>;
}